import React, {
  useEffect,
  useCallback,
} from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Typography,
  Stack,
} from '@mui/material'

import { STATUS_TYPE } from 'admin/config/status-type'
import { PAYMENT_TYPE } from 'admin/config/payment-type'
import { useStores } from 'admin/hooks'
import { formatDate, formatTimeOnly } from 'admin/utils/helper'
import CustomDataGrid from 'admin/components/data-grid'

const SyncButton = observer(({ id }) => {
  const { posStore } = useStores()

  const sync = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()
    if (id) posStore.syncPOSInvoice(id)
  }, [id])

  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={sync}
    >
      Sync
    </Button>
  )
})

const columns = [
  {
    field: 'id',
    headerName: 'ID',
    width: 160,
  },
  {
    field: 'paymentTypeId',
    headerName: 'Payment Types',
    width: 240,
    renderCell: (params) => (
      <Typography variant="h5">
        {params.row.paymentTypeId ?
          PAYMENT_TYPE.find((payment) => payment.id === params.row.paymentTypeId)?.name : '-'}
      </Typography>
    ),
  },
  {
    field: 'statusTypeId',
    headerName: 'Status',
    width: 240,
    renderCell: (params) => (
      <Typography variant="h5">
        {params.row.statusTypeId ?
          STATUS_TYPE.find((status) => status.id === params.row.statusTypeId)?.name : '-'}
      </Typography>
    ),
  },
  {
    field: 'droppedOffTime',
    headerName: 'Dropoff Time',
    width: 145,
    renderCell: (params) => (
      <Stack direction="column">
        <Typography variant="h5">
          {formatDate(params.row.droppedOffTime)}
        </Typography>
        <Typography variant="h5">
          {formatTimeOnly(params.row.droppedOffTime)}
        </Typography>
      </Stack>
    ),
  },
  {
    field: 'createdTime',
    headerName: 'Created at',
    width: 145,
    renderCell: (params) => (
      <Stack direction="column">
        <Typography variant="h5">
          {formatDate(params.row.createdTime)}
        </Typography>
        <Typography variant="h5">
          {formatTimeOnly(params.row.createdTime)}
        </Typography>
      </Stack>
    ),
  },
  {
    field: 'sync',
    headerName: 'Sync',
    width: 145,
    renderCell: (params) => (
      <SyncButton id={params.row.id} />
    ),
  },
]

const PosDatagridInvoice = () => {
  const { posStore, infoSectionStore } = useStores()

  const handlePageChange = useCallback((param) => {
    posStore.updatePage(param)
  }, [])

  const handlePageSizeChange = useCallback((param) => {
    posStore.updateRowsPerPage(param)
  }, [])

  const handleRowClick = useCallback((rowData) => {
    infoSectionStore.select(rowData.row)
  }, [])

  const onSortModelChange = (param) => {
    if (param.length === 1) {
      posStore.updateQuery('sortBy', param[0].field, true)
      posStore.updateQuery('sortDirection', param[0].sort, true)
      return
    }
    posStore.resetQuery()
  }

  useEffect(() => {
    posStore.fetchInvoice()
  }, [posStore.queryParams])

  return (
    <CustomDataGrid
      rows={posStore.list}
      columns={columns}
      handleRowClick={handleRowClick}
      handlePageChange={handlePageChange}
      rowCount={posStore.total}
      pageSize={posStore.rowsPerPage}
      page={posStore.currentPage}
      handlePageSizeChange={handlePageSizeChange}
      onSortModelChange={onSortModelChange}
      loading={posStore.loading}
      rowsPerPageOptions={[20]}
    />
  )
}

export default observer(PosDatagridInvoice)
